import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

const VERTICAL_SPACING = {
  normal: "normal",
  tight: "tight",
  high: "high",
};
// From TailwindUI: https://tailwindui.com/components/application-ui/forms/radio-groups

interface FieldsetProps {
  legend?: string;
  children: ReactNode;
  legendProps?: ComponentPropsWithoutRef<"legend">;
  divProps?: ComponentPropsWithoutRef<"div">;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  verticalSpacing?: (typeof VERTICAL_SPACING)[keyof typeof VERTICAL_SPACING];
}

export const Fieldset = ({
  onChange,
  legend = "",
  children,
  legendProps = {},
  divProps = {},
  verticalSpacing = VERTICAL_SPACING.normal,
  ...rest
}: FieldsetProps) => (
  <fieldset {...rest}>
    {legend && (
      <legend className="sr-only" {...legendProps}>
        {legend}
      </legend>
    )}
    <div
      onChange={onChange}
      className={classNames({
        "space-y-5": verticalSpacing == VERTICAL_SPACING.normal,
        "space-y-3": verticalSpacing == VERTICAL_SPACING.tight,
        "space-y-6": verticalSpacing == VERTICAL_SPACING.high,
      })}
      {...divProps}
    >
      {children}
    </div>
  </fieldset>
);
